import { render } from "./App.vue?vue&type=template&id=3d0d0dab"
const script = {}
script.render = render

export default script